export enum RestructuringType {
  /** Full Restructuring */
  FullRestructuring = 'FR',
  /** Modified Restructuring */
  ModifiedRestructuring = 'MR',
  /** Modified Mod Restructuring */
  ModifiedModRestructuring = 'MM',
  /** No Restructuring specified */
  NoRestructuringSpecified = 'XR',
}
